import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const FilledButton = ({
  text,
  width,
  buttonClass,
  buttonType,
  handleClick,
  disabled,
  className,
  hasTooltip,
  tooltipText,
  tooltipPosition,
}) => {
  const selectbuttonClass = color => {
    switch (color) {
      case 'cancel':
        return 'cancel';
      case 'confirm':
        return 'confirm';
      case 'warn':
        return 'warn';
      default:
        return 'default';
    }
  };

  const Button = (
    <S.Button
      width={width}
      type={buttonType}
      className={`${selectbuttonClass(buttonClass)}-button ${className}`}
      onClick={handleClick}
      disabled={disabled}
    >
      {text}
    </S.Button>
  );

  return (
    <>
      {disabled && hasTooltip ? (
        <S.ButtonContainer width={width}>
          {Button}
          <S.ButtonTooltip position={tooltipPosition}>
            <S.ButtonTooltipText>{tooltipText}</S.ButtonTooltipText>
          </S.ButtonTooltip>
        </S.ButtonContainer>
      ) : (
        Button
      )}
    </>
  );
};

export default FilledButton;

FilledButton.defaultProps = {
  handleClick: () => {},
  className: '',
  width: 'fit-content',
  buttonType: 'button',
  buttonClass: 'default',
  disabled: false,
  hasTooltip: false,
  tooltipText: '',
  tooltipPosition: 'bottom-right',
};

FilledButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  text: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  buttonType: PropTypes.string,
  buttonClass: PropTypes.string,
  handleClick: PropTypes.func,
  hasTooltip: PropTypes.bool,
  tooltipText: PropTypes.string,
  tooltipPosition: PropTypes.string,
};
